import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { mockOrders } from "../Datas/orderData";
import "../css/adminOrderDetails.scss"; 

function AdminOrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
  

    // Find order
    const foundOrder = mockOrders.find((o) => o.id === id);
    if (foundOrder) {
      setOrder(foundOrder);
    } else {
      // Handle not found
      // navigate("/admin/orders");
    }
  }, [id, navigate]);

  const handleBack = () => {
    navigate("/admin/orders");
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Delivered":
        return "status-delivered";
      case "Shipped":
        return "status-shipped";
      case "Processing":
        return "status-processing";
      case "Pending":
        return "status-pending";
      default:
        return "";
    }
  };

  if (!order) {
    return (
      <div className="admin-page">
        <Header />
        <div className="admin-container">
          <p>Loading order details...</p>
        </div>
        <Footer />
      </div>
    );
  }

 

  return (
    <div className="admin-page">
      <Header />
      <div className="admin-container">
        <div className="admin-header">
          <button onClick={handleBack} className="back-btn">
            &larr; Back to Orders
          </button>
        </div>

        <div className="order-details-container">
          <div className="details-section">
            <h2>Order Details: {order.id}</h2>
            <div className="info-grid">
              <div className="info-item">
                <label>Customer Name</label>
                <p>{order.customer}</p>
              </div>
              <div className="info-item">
                <label>Order Date</label>
                <p>{order.date}</p>
              </div>
              <div className="info-item">
                <label>Status</label>
                <span className={`status-badge ${getStatusClass(order.status)}`}>
                  {order.status.toUpperCase()}
                </span>
              </div>
            </div>
          </div>

          <div className="details-section">
            <h2>Shipping Information</h2>
            {order.shippingAddress ? (
              <div className="info-grid">
                <div className="info-item">
                  <label>Receiver</label>
                  <p>{order.shippingAddress.receiver}</p>
                </div>
                <div className="info-item">
                  <label>Phone</label>
                  <p>{order.shippingAddress.phone}</p>
                </div>
                <div className="info-item full-width">
                  <label>Address</label>
                  <p>{order.shippingAddress.address}</p>
                </div>
                {order.trackingNumber && (
                  <div className="info-item full-width">
                    <label>Tracking Number</label>
                    <p className="tracking-number">{order.trackingNumber}</p>
                  </div>
                )}
              </div>
            ) : (
              <p className="no-info">No shipping information available.</p>
            )}
          </div>

          <div className="details-section">
            <h2>Order Items</h2>
            <table className="items-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="item-info">
                        <img src={item.image} alt={item.name} className="item-thumb" />
                        <span>{item.name}</span>
                      </div>
                    </td>
                    <td>{item.quantity}</td>
                    <td>€{item.price.toFixed(2)}</td>
                    <td>€{(item.quantity * item.price).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3" className="total-label">Total Amount:</td>
                  <td className="total-amount">€{order.total.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AdminOrderDetails;
